import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Output, Input, ViewChild, OnDestroy } from '@angular/core';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { IvSignService, MetadataOperation } from '../../../../api';
import { UserService } from '../../../../api/api/user.service';
import { BiometrySignatureRequest } from '../../../../api/model/biometrySignatureRequest';
import { RequestBiometry } from '../../../../api/model/requestBiometry';
import { FinishProService } from '../../../services/finish-pro.service';
import { operationTypeEnum } from '../../../../models/operation-type';
import { loadTextFileAjaxSync } from '../../../../core/utils/load-ajax-basic';
import { ProfileService } from '../../../../core/profile/profile.service';
import { IvPadComponent } from '../../../../shared/components/iv-pad/iv-pad.component';
import { WidgetSettings } from '../../../../finish-pro/models/documents/documents';
import { InputData } from '../../../pages/document-viewer/types/document-viewer-types';
import { DocumentListObserve } from '../../../../finish-pro/models/operations/document-list-observe';
import { EncodeB64Service } from '../../../../base/services/encode-b64/encode-b64.service';
import { v4 as uuidv4 } from 'uuid';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';

@Component({
  selector: 'signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss'],
  providers: [IvSignService, UserService]
})
export class SignaturePadComponent implements AfterViewInit, OnDestroy {
  /**
   * IvPad component from ivpad librarie.
   */
  @ViewChild('ivpad') ivpad: IvPadComponent;

  /**
   * Event triggered after finish the signature.
   */
  @Output() afterSigned: EventEmitter<any[]> = new EventEmitter();

  /**
   * Event triggered when there's an error.
   */
  @Output() onError = new EventEmitter();

  /**
   * String containing the IvSign token
   */
  token: string = null;

  /**
   * Array containing the signed documents.
   */
  signed: any[] = null;

  /**
   * Boolean for set if the circuit has an afterview event
   */
  afterView = false;

  /**
   * Obteins device
   */
  elementType = NgxQrcodeElementTypes.URL;

  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;

  /**
   * Variable that contains the url
   */
  routeQR: string = '';

  /**
   * Array for the pdf form fields data
   */
  metadataDocument: Array<MetadataOperation> = [];

  /**
   * Obteins device
   */
  mobile: boolean;

  /**
   * Verify if setting of pressure is active
   */
  verifyPressure: number;

  /**
   * Verify if device if allowed for biometric sign
   */
  deviceAllowed: boolean = true;

  socketId: string = uuidv4();

  @Output() signature: EventEmitter<string> = new EventEmitter();

  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @Output() gesture: EventEmitter<boolean> = new EventEmitter();

  @Input() doc: string;

  @Input() widgetSigBio: WidgetSettings[];

  @Input() docFields: InputData[];

  @Input() metadataViewer: MetadataOperation[];

  @Output() documentSigned = new EventEmitter();

  /**
   * Connect webSocket
   */
  webSocket: WebSocketSubject<any>;

  /**
   * ID of the operation sent by the websocket server
   */
  idOperationQR: string

  idDoc: string

  biometry: boolean;

  isOperationFinished: boolean = false;

  _transParam: boolean = false;

  metadataEditable: MetadataOperation[] = [];

  indexPDF: number = 0;

  dataSigns: Array<string> = [];

  documentB64: string = '';

  pdfs = [];

  connectionId: string = '';

  webSocketURL: string = 'wss://sigsocketspro.apps.signa.run';

  constructor(
    private _ivSignService: IvSignService,
    private _ref: ChangeDetectorRef,
    private _finishProService: FinishProService,
    private _profile: ProfileService,
    private _encoder: EncodeB64Service) { }

  ngAfterViewInit() {
    const userTouch = navigator.maxTouchPoints;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
      this.mobile = true;
    } else {
      this.mobile = userTouch !== 0 ? true : false;
    }
    this.setData();
    this.ivpad.changeConfig({ autoDownload: false, showButtons: false });
    this.ivpad.disableErrors();
    this.ivpad.disableLoading();
    this.ivpad.signatureCanvas.setOptions('backgroundColor', 'rgba(0,0,0,0)');
    this.afterView = true;
    if (this._finishProService.operationDetailResponse.operationType === operationTypeEnum.SIGBIO) {
      this.setBiometry(true);
    }
    this.pdfs = this._finishProService.documentListResponse.filter(res => res.type === 1);
    this._ref.detectChanges();
    this.validateWebSocket();
    this.webSocket = webSocket({
      url: `${this.webSocketURL}/ivcert?id=${this.socketId}&group=${this._finishProService.operationId}&type=1`,
      closeObserver: {
        next: () => {
          this.routeQR = '';
        }
      },
      openObserver: {
        next: () => {
          this.activateQR();
        }
      }
    })

    this.webSocket.subscribe(response => {
      if(response.Message){
        const message = JSON.parse(response.Message);
        if(message.Type === 3){
          if (this._finishProService.operationDetailResponse.operationType === operationTypeEnum.SIGBIO) {
            if (message.SendToParent == "boolean") {
              this.deviceAllowed = message.SendToParent;
              this._finishProService.pressureDeviceSigBio = this.deviceAllowed;
            }
            else {
              this.ivpad?.signatureCanvas.fromData(JSON.parse(message.SendToParent.data));
              this.signature.emit(message.SendToParent.sign);
              this._finishProService.pressureDeviceSigBio = true;
              this.sign();
            }
          } else {
            this.signature.emit(message.SendToParent.sign);
            this.closePad();
          }

        }
        else if (message.Type === 2) {
          if(!this.connectionId || message.Id !== this.connectionId){
            this.connectionId = message.Id;
            document.getElementById('container-pad').style.pointerEvents = 'none';
          }
          else {
            document.getElementById('container-pad').style.pointerEvents = 'all'
          }
        }
      }
    })
  }

  ngOnDestroy() {
    this.webSocket.complete();
  }

    validateWebSocket() {
    const url = window.location.href;

    if (url.includes('.qatest') || url.includes('.test')) {
      this.webSocketURL = 'wss://sigsocketspre.apps.signa.run';
    } else {
      this.webSocketURL = 'wss://sigsocketspro.apps.signa.run';
    }
  }

  closePad(): void {
    this.close.emit(true);
  }

  activateQR(): void {
    this.routeQR = window.location.href + '/webSocketProOperation?id=' + this._finishProService.operationId;
  }

  setData(): void {
    if (this._finishProService.operationDetailResponse?.operationType === operationTypeEnum.SIGBIO) {
      this.verifyPressure = this._finishProService.operationDetailResponse.pressureSIGBIO;

      if (navigator.maxTouchPoints <= 0) {
        this.deviceAllowed = false;
      }
    }

    this._finishProService.pressureDeviceSigBio = this.deviceAllowed;
  }

  clearSign(): void {
    this.ivpad.clearSign();
  }

  async sign(): Promise<void> {
    if(this.isOperationFinished){
      return;
    }
    this.isOperationFinished = true;
    this.setEditableMetadata();

    if (this.ivpad.signatureCanvas.isEmpty()) {
      this.isOperationFinished = false;
      return;
    }

    const sig = this.ivpad.signatureCanvas.toDataURL('image/png').replace('data:image/png;base64,', '');

    if (this._finishProService.operationDetailResponse.operationType === operationTypeEnum.SIGBIO) {
      await this.getB64Document(this.pdfs[0].idDocument);
      this.signPdfs(0);
    }

    const hasNotCheckedSignature = !this.ivpad.checkSignature();

    if (hasNotCheckedSignature) {
      this.signature.emit(sig);

      if (this._finishProService.operationDetailResponse.operationType !== operationTypeEnum.SIGBIO) {
        this.closePad();
      }
    }
  }

  /**
   * Function that sets the configuration of the biometry signature.
   * @param {boolean} biometry Boolean that controls if is a biometry signature.
   */
  setBiometry(biometry: boolean): void {
    this.biometry = biometry;
    if (this.afterView) {
      this.ivpad?.setBiometry(biometry);
      if (biometry) {
        this.getToken(this.token);
        this.ivpad?.setPublicKey(this.getPublicKey());
      }
    }
    this._ref.detectChanges();
  }

  /**
   * The function obtains the cert's public key for sign
   */
  private getPublicKey(): string {
    const key = this.loadJSON('assets/cer/cer.json').key;
    return key;
  }

  /**
   * Function that obtains a json and returns an object from it.
   * @param {String} filePath String that contains the filepath.
   */
  loadJSON(filePath: string): any {
    const json = loadTextFileAjaxSync(filePath, 'application/json');
    return JSON.parse(json);
  }

  private getToken(token?: string): void {
    this._ivSignService.ivSignGetSigBio(token || '0').subscribe(
      (response) => {
        this.ivpad?.setToken(response.data);
      },
      (error) => {
        this.onError.emit(error);
      }
    );
  }

  async signPDF(request: BiometrySignatureRequest): Promise<void> {
    this.metadataDocument = [];

    for (let i = 0; i < this.pdfs.length; i++) {
      if (this.indexPDF == i) {
        this.metadataDocument.push({ key: 'idOperationToSign', value: this._finishProService.operationId });
        this.metadataDocument.push({ key: 'idDocumentToSign', value: this.pdfs[i].idDocument });
      }
    }

    const finalRequest: RequestBiometry = {
      request: request,
      metadataDocument: this.metadataDocument,
    };
    this.indexPDF++;
    if (this.pdfs[this.indexPDF]) {
      this.getB64Document(this.pdfs[this.indexPDF].idDocument);
    }
    if (this.metadataViewer.length) {
      finalRequest.metadataDocument = this.getMetadataEditable();
    }
    await this._ivSignService.ivSignBiometrySignature(finalRequest, this._profile.getToken() || '1').toPromise().then(
      (response) => {
        // @ts-ignore EL BEAN DEL SWAGGER NO CORRESPONDE A LA RESPUESTA
        this.dataSigns.push({ idDocument: this.pdfs[this.indexPDF - 1].idDocument, data: response.data });
        if (this.indexPDF === this.pdfs.length) {
          this.isOperationFinished = false;
          this.documentSigned.emit(this.dataSigns);
          this.closePad();
        } else {
          this.signPdfs(this.indexPDF);
        }
      },
      (error) => {
        this.isOperationFinished = false;
        console.log(error);
      }
    );
  }

  getMetadataEditable(): MetadataOperation[] {
    return this.metadataDocument.concat(this.metadataViewer);
  }

  async getB64Document(idDocument: string): Promise<void> {
    await this._finishProService.getDownloadDocumentCircuit(DocumentListObserve.RESPONSE, idDocument, false, false);
    this.documentB64 = this._encoder.arrayBufferToBase64(this._finishProService.documentBuffer);
  }

  async signPdfs(index: number): Promise<void> {
    const widget = this.widgetSigBio.filter(res => res.doc === this.pdfs[index].idDocument);
    if (widget.length && widget) {
      let width = '165';
      let height = '213';
      const design = JSON.parse(widget[0].design);
      width = design.width;
      height = design.height;
      this.setWidget({
        x: Math.round(widget[0].positionX),
        y: Math.round(widget[0].positionY),
        page: widget[0].page,
        w: Math.round(Number(width)),
        h: Math.round(Number(height))
      });
    } else {
      this.setWidget({
        x: 0,
        y: 0,
        page: 'all',
        w: 84,
        h: 84,
      });
    }
    this.ivpad.pdf = this.documentB64;
    this.ivpad?.setPdf(this.documentB64);
    this.ivpad?.signPDF(false, true);
  }

  setWidget(data: any): void {
    this.ivpad?.setSealPosition(data.x, data.y, data.page);
    this.ivpad?.setSealSize(data.w, data.h);
  }

  setEditableMetadata(): void {
    this.docFields?.forEach(field => {
      const metadata = { key: field.name, value: field.value || '' };
      if (field.type === 'radio') {
        if (field.value) metadata.value = field.buttonValue;
      }
      if (metadata.value) {
        this.metadataEditable.push(metadata);
      }
    })
  }

}
